import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { DashboardActionTypes } from './types'
import { listSuccess, listError } from './actions'
import { GeneralUtil } from '../../utils/generalUtil';
import { Table } from '../interface'

const generalUtil: GeneralUtil = new GeneralUtil();

const getDashboardStatistic = async (searchParams: any) => {
  return await generalUtil.GetDashboardStatistic(searchParams);
}

function* handleList(action: any) {
  try {
    const res = yield call(getDashboardStatistic, action.payload);
    if (res.isSuccess) {
      yield put(listSuccess(res))
    } else {
      yield put(listError({"errors": res.errors}))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(listError(err.stack))
    } else {
      yield put(listError('An unknown error occured.'))
    }
  }
}

function* watchListRequest() {
  yield takeEvery(DashboardActionTypes.LIST_REQUEST, handleList)
}

function* DashboardSaga() {
  yield all([
    fork(watchListRequest)
  ]);
}

export default DashboardSaga
